export default "/static/dashboard/build/app/img/v2/c1ad3489a3a462fbe5749539cc92b90b.png";